import React from 'react';

const ChiSiamo = () => {
  return (
    <div>
      <h1>Cos'è Just4Fun?</h1>
      <p>Just4Fun è una community dove puoi giocare, divertirti, stare in compagnia con altri player e molto altro.</p>
    </div>
  );
};

export default ChiSiamo;
